import { render, staticRenderFns } from "./IconCamera.vue?vue&type=template&id=bdfde224&functional=true&"
import script from "./IconCamera.vue?vue&type=script&lang=js&"
export * from "./IconCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports